module.exports = "/_next/static/images/7677feced7860fd8098afc92eea04c18-woman-playing-with-her-kids@xs.jpg";